<div [formGroup]="landServicesAccountingForm" class="accountingForm">
  <div class="accountingContainer">
    <!-- Capital Form Group -->
    <div class="subHeader">
      <span>Capital</span>
    </div>
    <div class="fieldsContainer" formGroupName="capital">
      <div class="fieldRow">
        <div class="fieldGroup">
          <span class="fieldLabel">Business Unit</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="businessUnit"
              [disabled]="reviewMode"
              [class.disabledField]="reviewMode"
            >
              @for (bu of capitalBusinessUnits; track bu) {
                <mat-option [value]="bu">
                  {{ bu }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Responsibility Center</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="responsibilityCenter"
              [disabled]="reviewMode || capitalRespCenters.length === 0"
              [class.disabledField]="reviewMode"
            >
              @for (rc of capitalRespCenters; track rc) {
                <mat-option [value]="rc">
                  {{ rc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Operating Unit</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="operatingUnit"
              [disabled]="reviewMode || capitalOperatingUnits.length === 0"
              [class.disabledField]="reviewMode"
            >
              @for (ou of capitalOperatingUnits; track ou) {
                <mat-option [value]="ou">
                  {{ ou }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Account</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="account"
              [disabled]="reviewMode || capitalAccounts.length === 0"
              [class.disabledField]="reviewMode"
            >
              @for (acc of capitalAccounts; track acc) {
                <mat-option [value]="acc">
                  {{ acc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Process Code</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="processCode"
              [disabled]="reviewMode || capitalProcessCodes.length === 0"
              [class.disabledField]="reviewMode"
            >
              <mat-option [value]="''">None</mat-option>
              @for (pc of capitalProcessCodes; track pc) {
                <mat-option [value]="pc">
                  {{ pc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Project Id (Auto populated)</span>
          <mat-form-field class="fieldValue">
            <input matInput formControlName="projectId" readonly class="disabledField" />
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Activity ID</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="activityId"
              [disabled]="reviewMode"
              [class.disabledField]="reviewMode"
            >
              @for (activity of getFilteredActivities('capital'); track activity) {
                <mat-option [value]="activity.valueId">
                  {{ activity.valueId }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Resource Type</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="resourceType"
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Project Charge Indicator (Prefilled RWIP)</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="projectChargeIndicator"
              readonly
              [class.disabledField]="true"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- O&M Form Group -->
    <div class="subHeader">
      <span>O&M</span>
    </div>
    <div class="fieldsContainer" formGroupName="om">
      <div class="fieldRow">
        <div class="fieldGroup">
          <span class="fieldLabel">Business Unit</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="businessUnit"
              [disabled]="reviewMode"
              [class.disabledField]="reviewMode"
            >
              @for (bu of omBusinessUnits; track bu) {
                <mat-option [value]="bu">
                  {{ bu }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Responsibility Center</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="responsibilityCenter"
              [disabled]="reviewMode || omRespCenters.length === 0"
              [class.disabledField]="reviewMode"
            >
              @for (rc of omRespCenters; track rc) {
                <mat-option [value]="rc">
                  {{ rc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Operating Unit</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="operatingUnit"
              [disabled]="reviewMode || omOperatingUnits.length === 0"
              [class.disabledField]="reviewMode"
            >
              @for (ou of omOperatingUnits; track ou) {
                <mat-option [value]="ou">
                  {{ ou }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Account</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="account"
              [disabled]="reviewMode || omAccounts.length === 0"
              [class.disabledField]="reviewMode"
            >
              @for (acc of omAccounts; track acc) {
                <mat-option [value]="acc">
                  {{ acc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Process Code</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="processCode"
              [disabled]="reviewMode || omProcessCodes.length === 0"
              [class.disabledField]="reviewMode"
            >
              <mat-option [value]="''">None</mat-option>
              @for (pc of omProcessCodes; track pc) {
                <mat-option [value]="pc">
                  {{ pc }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Project Id (Auto populated)</span>
          <mat-form-field class="fieldValue">
            <input matInput formControlName="projectId" readonly class="disabledField" />
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Activity ID</span>
          <mat-form-field class="fieldValue">
            <mat-select
              formControlName="activityId"
              [disabled]="reviewMode"
              [class.disabledField]="reviewMode"
            >
              @for (activity of getFilteredActivities('om'); track activity) {
                <mat-option [value]="activity.valueId">
                  {{ activity.valueId }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Resource Type</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="resourceType"
              [readonly]="reviewMode"
              [class.disabledField]="reviewMode"
            />
          </mat-form-field>
        </div>

        <div class="fieldGroup">
          <span class="fieldLabel">Project Charge Indicator (Prefilled RWIP)</span>
          <mat-form-field class="fieldValue">
            <input
              matInput
              formControlName="projectChargeIndicator"
              readonly
              [class.disabledField]="true"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
